import CacheEnabledApiClient from './CacheEnabledApiClient';
import axios from 'axios';

class LabelsAPI extends CacheEnabledApiClient {
  constructor() {
    super('labels', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'label';
  }

  deleteContactAutomationTrigger(labelId, triggerId) {
    return axios.delete(`${this.url}/${labelId}/delete_contact_automation_trigger/${triggerId}`);
  }
}

export default new LabelsAPI();
